import { render, staticRenderFns } from "./institutionList.vue?vue&type=template&id=3e9b2fb6&scoped=true&"
import script from "./institutionList.vue?vue&type=script&lang=js&"
export * from "./institutionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9b2fb6",
  null
  
)

export default component.exports